import tw from "twin.macro"

import { StyledButton } from "../Styled/Button"
import { H4 } from "../Styled/Text"

export const Stats = tw.section`bg-teal-mint pt-48 md:pt-36.5 text-navy border-b border-teal pb-12 md:pb-16`
export const Button = tw(StyledButton)`w-full`
export const Circle = tw.div`w-20 h-20 mb-6 md:mb-0 flex items-center justify-center bg-navy text-white rounded-full`
export const Title = tw(H4)`md:text-2.25xl leading-normal`
